import { Corner } from "../types";

export const SNAP_THRESHOLD_PCT = 1.5;

export const CORNERS: Corner[] = ["nw", "ne", "sw", "se"];

/**
 * Зазор между canvas (область экспорта) и внешним краем превью. Внутри
 * этой зоны можно "разместить" overlay, чтобы посмотреть как он обрежется
 * sharp'ом на бэке. Снаружи — box overflow:hidden, overlay перестаёт
 * быть виден.
 */
export const GUTTER_PX = 50;

/**
 * Fallback aspect-ratio для canvas'а, пока подложка ещё не загрузилась.
 * 1/1 нейтрален: skeleton имеет понятный размер, для большинства карточек
 * товаров это близко к реальному aspect-ratio фотки.
 */
export const DEFAULT_CANVAS_ASPECT_RATIO = "1 / 1";

export const LABELS = {
  bgError: "Не удалось загрузить подложку",
  overlayError: "Не удалось загрузить изображение. Проверьте ссылку.",
  defaultEmptyHint: "Добавьте изображение — оно появится поверх подложки",
  overlayAria:
    "Перетащите для перемещения, тяните за углы для изменения размера",
  resizeHandleAria: (corner: Corner) =>
    `Изменить размер от угла ${corner.toUpperCase()}`,
} as const;
